import React from 'react'
import { Link } from 'react-router-dom'

import Logo from '../../../common/assets/logo.js'
//import Namer from '../../components/namer'

export default () => {
	return (
		<div className="canvas">
			<div className="canvas__track">
				<div className="u-width-wrap">
					{/* <Namer /> */}
					<div className="cta-container">
						<Logo />
						<h1 className="headline">Watch Skate Videos</h1>
						<ul className="value-props">
							<li className="value-prop value-prop--show">All your favorites. All in one place.</li>
							{/* <li className="value-prop">Full-length skate videos and parts.</li>
							<li className="value-prop">Classics and current skate videos.</li>
							<li className="value-prop">New skate videos added regularly.</li> */}
						</ul>
						<div className="cta-buttons">
							<Link className="cta-button cta-button--join" to="signup">Join For Free</Link>
							<Link className="cta-button cta-button--sign-in" to="login">Sign In</Link>
						</div>
					</div>
					<p className="copyright">&copy 2018 5FORTY</p>
				</div>
			</div>
		</div>
	)
}



// WEBPACK FOOTER //
// ./src/mobile/pages/home/index.js